/* Homepage interactive elements: scent picker + waste calculator. */

if (!customElements.get('mov-scent-picker')) {
  customElements.define(
    'mov-scent-picker',
    class MovScentPicker extends HTMLElement {
      connectedCallback() {
        this.chips = [...this.querySelectorAll('[data-scent-chip]')];
        this.panels = [...this.querySelectorAll('[data-scent-panel]')];
        this.chips.forEach((chip) =>
          chip.addEventListener('click', () => this.select(chip.dataset.scentChip))
        );
        // A tap anywhere on a scent card opens its button's page (Clarity: phones tap the name, notes and picture).
        this.panels.forEach((panel) => {
          const cta = panel.querySelector('.mov-scent-picker__cta');
          if (!cta) return;
          panel.addEventListener('click', (e) => {
            if (e.target.closest('a, button')) return;
            cta.click();
          });
        });
      }

      select(index) {
        this.chips.forEach((c) => c.classList.toggle('is-active', c.dataset.scentChip === index));
        this.panels.forEach((p) => p.classList.toggle('is-active', p.dataset.scentPanel === index));
      }
    }
  );
}

if (!customElements.get('mov-calculator')) {
  customElements.define(
    'mov-calculator',
    class MovCalculator extends HTMLElement {
      connectedCallback() {
        this.years = 1;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pills = [...this.querySelectorAll('[data-years]')];
        this.pills.forEach((pill) =>
          pill.addEventListener('click', () => {
            this.years = parseInt(pill.dataset.years, 10) || 1;
            this.pills.forEach((p) => p.classList.toggle('is-active', p === pill));
            this.render();
          })
        );
        // First render counts up when the section scrolls into view.
        const io = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              this.render();
              io.disconnect();
            }
          },
          { threshold: 0.4 }
        );
        io.observe(this);
      }

      render() {
        const sticksPerYear = parseInt(this.dataset.sticksPerYear, 10) || 6;
        const grams = parseInt(this.dataset.gramsPerStick, 10) || 40;
        const savings = parseInt(this.dataset.savingsPerYear, 10) || 54;
        const sticks = sticksPerYear * this.years;
        const plastic = sticks * grams;

        this.animate(this.querySelector('[data-calc-sticks]'), sticks, (v) => String(Math.round(v)));
        this.animate(this.querySelector('[data-calc-plastic]'), plastic, (v) =>
          v >= 1000 ? (v / 1000).toFixed(1) + ' kg' : Math.round(v) + ' g'
        );
        this.animate(this.querySelector('[data-calc-refills]'), sticks, (v) => String(Math.round(v)));
        this.animate(this.querySelector('[data-calc-savings]'), savings * this.years, (v) => this.money(v));
        this.animate(this.querySelector('[data-calc-overspend]'), savings * this.years, (v) => this.money(v));
      }

      // French money reads "54 $", not "$54".
      money(v) {
        const n = Math.round(v);
        return (document.documentElement.lang || '').toLowerCase().startsWith('fr') ? n + ' $' : '$' + n;
      }

      animate(el, target, format) {
        if (!el) return;
        if (this.reduceMotion) {
          el.textContent = format(target);
          return;
        }
        const start = parseFloat(el.dataset.value || '0');
        const t0 = performance.now();
        const duration = 500;
        const tick = (t) => {
          const p = Math.min((t - t0) / duration, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          el.textContent = format(start + (target - start) * eased);
          if (p < 1) requestAnimationFrame(tick);
          else el.dataset.value = String(target);
        };
        requestAnimationFrame(tick);
      }
    }
  );
}
